<template>
  <div>
    <v-container fluid>
      <!-- TOP PART -->
      <v-row>
        <v-col cols="4">
          <h4>{{ $t("ration.prepareRelation") }}</h4>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="4" class="text-center">
          <p v-if="rationType == 'system'">
            Step 2 of 2 | {{ $t("ration.animalSelection") }}
          </p>
          <p v-else>Step 3 of 3 | {{ $t("ration.animalSelection") }}</p>
        </v-col>
        <v-spacer></v-spacer>

        <v-col cols="4" class="text-right"> </v-col>
      </v-row>
      <v-divider class="my-4"></v-divider>

      <!-- INGREDIENTS SELECTIONS HERE -->

      <v-row class="pb-3">
        <v-col cols="8">
          <h3>
            {{ $t("ration.rationSuggestion") }} - For
            {{ this.groupIngradients.rationAnimalGroups?.length }} Groups
          </h3>
        </v-col>
        <v-col cols="4" class="text-right">
          <v-btn outlined color="primary" class="mr-2" @click="back">
            Back
          </v-btn>
          <v-btn
            color="primary"
            @click="openCreateRationDialog"
            :disabled="enableSaveRationBtn()"
          >
            Save Ration(s)
          </v-btn>
        </v-col>
      </v-row>
      <v-card
        elevation="0"
        class="my-2"
        v-for="ingradient in groupIngradients.rationAnimalGroups"
        :key="ingradient.id"
      >
        <v-card-text>
          <div
            :class="
              isExpanded[ingradient.groupId]
                ? 'orange2 my-2 px-4'
                : 'gray2 my-2 px-4'
            "
            style="border-radius: 2px"
          >
            <v-row>
              <v-col cols="4" class="d-flex justify-start align-center">
                <!-- <p class="mb-0"> -->
                <v-icon @click="expandToggle(ingradient.groupId)">{{
                  isExpanded[ingradient.groupId]
                    ? "mdi-chevron-up"
                    : "mdi-chevron-down"
                }}</v-icon>
                ({{ ingradient.subGroup?.length }}) {{ ingradient.groupName }}
                <!-- <v-checkbox
                  :hide-details="true"
                  v-if="ingradient.subGroup?.length"
                  class="ml-3"
                  @click="applyToAllSubGroup(ingradient)"
                ></v-checkbox>
                Apply to all Sub-Groups -->
                <!-- </p> -->
              </v-col>
              <v-col cols="8" class="d-flex align-center justify-end">
                <v-alert
                  class="mx-4"
                  dense
                  color="#FAF5DA"
                  style="
                    border: 1px solid #ffb443;
                    align-items: center !important;
                    margin-bottom: 0px !important;
                    font-size: 14px;
                    max-width: 547px;
                  "
                  v-if="
                    ingradient.ration.status_type == 'active' ||
                    ingradient.ration.status_type == 'suggested'
                  "
                >
                  Ration Name:
                  <b>{{ ingradient.ration.rationName || "_______" }}</b
                  >&nbsp;&nbsp;&nbsp;

                  <span v-if="ingradient.ration.status_type == 'active'"
                    >For the period:
                  </span>
                  <b v-if="ingradient.ration.status_type == 'active'"
                    >{{ ingradient.ration.duration || 0 }}
                  </b>
                  &nbsp;&nbsp;<v-icon
                    color="blue"
                    class="pl-1"
                    @click="
                      openRationCreateModal(
                        ingradient,
                        getSaveRationType(ingradient)
                      )
                    "
                    >mdi-pencil</v-icon
                  >
                </v-alert>

                <p class="mb-0">
                  <!-- <span class="gray--text body-2">Sub Groups</span>
                  <span
                    @click="
                      getSubGroupAnimalDetails(ingradient.subGroup, subgroup)
                    "
                    class="text-decoration-underline green--text divider"
                    v-for="subgroup in ingradient.subGroup"
                    :key="subgroup.id"
                    >{{ subgroup.subGroupName }}</span
                  > -->
                  <v-btn
                    v-if="
                      !saveBtnCondtion.includes(ingradient.ration.status_type)
                    "
                    color="green white--text"
                    height="40px"
                    @click="openRationCreateModal(ingradient, 'start-using')"
                    >START USING</v-btn
                  >
                  <v-btn
                    v-if="
                      !saveBtnCondtion.includes(ingradient.ration.status_type)
                    "
                    color="green white--text"
                    class="ml-2"
                    height="40px"
                    @click="openRationCreateModal(ingradient, 'suggestion')"
                    >SAVE AS SUGGESTION</v-btn
                  >
                  <v-icon
                    color="error"
                    class="pl-2"
                    @click="removeRation(ingradient)"
                    >mdi-trash-can</v-icon
                  >
                </p>
              </v-col>
            </v-row>
          </div>

          <v-card-text
            :style="
              isExpanded[ingradient.groupId] ? 'display:block' : 'display:none'
            "
            v-for="subGroup in ingradient.subGroup"
            :key="subGroup.id"
          >
            <div class="gray2 my-2 px-4">
              <v-row>
                <v-col cols="6" class="">
                  <p class="d-flex align-center justify-start mb-0">
                    <v-icon @click="expandToggle(subGroup.id)">{{
                      isExpanded[subGroup.id]
                        ? "mdi-chevron-up"
                        : "mdi-chevron-down"
                    }}</v-icon>
                    {{ subGroup.subGroupName }}
                  </p>
                </v-col>
              </v-row>
            </div>
            <!-- {{ $t("ration.rationSummary") }} INNER COMPONENTS -->
            <span
              :style="
                isExpanded[subGroup.id] ? 'display:block' : 'display:none'
              "
            >
              <!-- <ration-summary-component
                :suggestedRations="ingradient"
                :selectedCardGroupData="selectedCardData"
                :rationPriority="rationPriority"
                @generateAllData="generateAllData"
                @rationData="generateRations"
                @currentSubGroup="setCurrentSubGroup"
              ></ration-summary-component> -->

              <ration-suggestion-summary-component
                :suggestedRations="ingradient"
                :subGroup="subGroup"
                :rationPriority="rationPriority"
                :selectedCardGroupData="selectedCardData"
                @generateAllData="generateAllData"
                @rationData="generateRations"
                @currentSubGroup="setCurrentSubGroup"
              ></ration-suggestion-summary-component>
            </span>
          </v-card-text>
        </v-card-text>
      </v-card>
    </v-container>
    <sub-group-animal-details
      v-if="showSubGroupAnimalDetails"
      :dialogI="showSubGroupAnimalDetails"
      @closeDialog="showSubGroupAnimalDetails = false"
      :subGroups="subGroups"
      :rationAnimalGeneratedSubGroupId="rationAnimalGeneratedSubGroupId"
    >
    </sub-group-animal-details>
    <save-ration-dialog
      v-if="saveRation"
      :dialogI="saveRation"
      :rationLists="currentRationGroup"
      :saveRationType="saveRationType"
      @closeDialog="saveRation = false"
      @rationCreated="rationCreated"
    >
    </save-ration-dialog>
    <create-ration-dialog
      v-if="createRation"
      :noOfSavedRations="groupIngradients.rationAnimalGroups?.length"
      :dialogU="createRation"
      @closeDialog="createRation = false"
    >
    </create-ration-dialog>

    <confirm-box
      v-if="deleteRation"
      :dialog="deleteRation"
      title="Warning"
      message="Are you sure you want to delete this record?"
      confirmBtnText="Delete"
      :confirmData="itemToDelete"
      @confirm:action="deleteRationConfirmed"
    />

    <!-- <confirm-box
      v-if="deleteSuggestion"
      :dialog="deleteSuggestion"
      title="Warning"
      message="Are you sure you want to delete this record?"
      confirmBtnText="Delete"
      :confirmData="itemToDelete"
      @confirm:action="deleteIngredientSuggestionConfirmed"
    /> -->
  </div>
</template>
<script>
import SubGroupAnimalDetails from "@/views/feed_management/ration_library/DialogBox/SubGroupAnimalDetails";
import SaveGroupRationDialog from "@/views/feed_management/ration_library/DialogBox/SaveGroupRationDialog";
import CreateRation from "@/views/feed_management/ration_library/DialogBox/RationSaveSuccessDialog";
import loadingMixin from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";
import ConfirmBox from "@/components/ConfirmBox.vue";

import {
  generateSuggestions,
  GenerateIngredientAllGroup,
} from "@/graphql/FeedMgmt.gql";
import { removeRation } from "@/graphql/Feed.gql";
import { mapGetters } from "vuex";

// COMPONENTS
// import RationSummaryComponent from "@/views/feed_management/ration_library/components/_RationSummary";
import RationSuggestionSummaryComponent from "@/views/feed_management/ration_library/components/_RationSuggestionSummary";
import FeedService from "@/_services/FeedService";
export default {
  components: {
    "sub-group-animal-details": SubGroupAnimalDetails,
    "save-ration-dialog": SaveGroupRationDialog,
    "create-ration-dialog": CreateRation,
    // "ration-summary-component": RationSummaryComponent,
    "ration-suggestion-summary-component": RationSuggestionSummaryComponent,
    "confirm-box": ConfirmBox,
  },
  computed: {
    ...mapGetters(["getRationSuggestionInput", "rationIdForIngredientList"]),
  },
  data() {
    return {
      isExpandedFirst: false,
      deleteRation: false,
      saveBtnCondtion: ["active", "suggested"],
      isExpanded: {},
      isExpandedSecond: false,
      saveRation: false,
      createRation: false,
      showSubGroupAnimalDetails: false,
      groupIngradients: [],
      subGroups: [],
      rationAnimalGeneratedSubGroupId: null,
      rationLists: [],
      dataForGenerateAll: [],
      rationId: null,
      currentSubGroupId: null,
      selectedCardData: [],
      rationType: "",
      rationPriority: null,
      itemToDelete: null,
      deleteSuggestion: false,
      saveRationType: null,
      currentRationGroup: null,
    };
  },
  created() {
    this.rationPriority = this.$route.query.rationPriority;
  },
  mounted() {
    this.rationType = this.$route.query.rationType;
    this.rationPriority = this.$route.query.rationPriority;
    this.getFeedSuggestions();
    this.updateRationId();
  },
  methods: {
    openCreateRationDialog() {
      this.createRation = true;
    },
    enableSaveRationBtn() {
      let data = this.groupIngradients.rationAnimalGroups.map(s => {
        return ["active", "suggested"].includes(s.ration.status_type);
      });

      return data.includes(false) ? true : false;
    },
    getSaveRationType(ingradient) {
      return ingradient.ration.status_type == "active"
        ? "start-using"
        : "suggested";
    },
    removeRation(item) {
      this.itemToDelete = item;
      this.deleteRation = true;
    },
    deleteRationConfirmed(action, item) {
      if (action) {
        this.startLoading();
        this.$apollo
          .mutate({
            mutation: removeRation,
            variables: {
              id: parseInt(item.ration.rationId),
            },
          })
          .then(async ({ data }) => {
            if (data.removeRation.success) {
              this.stopLoading();
              this.$notify({
                title: "Success!",
                text: "Ration deleted successfully!",
                type: "success",
              });

              const rationToRemove = { rationId: item.ration.rationId };
              this.$store.commit("deleteRationSuggestionInput", rationToRemove);
              // const query = Object.assign({}, this.$route.query);
              // let rationIdArr = query.rationId.filter((id) => id !== 929);
              // query.rationId = rationIdArr;
              // this.$router.replace({ query });

              this.getFeedSuggestions();
            }
          })
          .catch(e => {
            console.log("arc", e);
            this.stopLoading();
          });
      }
      this.itemToDelete = null;
      this.deleteRation = false;
    },
    // destroyGroupSuggestionDialog(data) {
    //   this.itemToDelete = data;
    //   this.deleteSuggestion = true;
    //   this.this.startLoading();
    // },
    // async deleteGroupSuggestionConfirmed(action, item) {
    //   console.log(item);
    //   if (action) {
    //   }
    // },
    closeDialog() {
      this.saveRation = false;
      this.generateSuggestions.refetch();
    },

    openRationCreateModal(item, type) {
      this.currentRationGroup = item;
      this.saveRationType = type;
      this.saveRation = true;
    },
    applyToAllSubGroup(ingredients) {
      if (
        this.dataForGenerateAll.findIndex(
          data => data.groupId == ingredients.groupId
        ) == -1
      ) {
        this.$notify({
          title: "Error!",
          text: "Please select subgroup ingredients!!",
          type: "error",
        });
        return;
      }

      const groupIndex = this.dataForGenerateAll.findIndex(
        data => data.groupId == ingredients.groupId
      );

      const subGroupDetail = this.dataForGenerateAll[
        groupIndex
      ].subGroupIngredients.filter(
        sub => sub.subGroupId == this.currentSubGroupId
      );

      for (let subgroup of ingredients.subGroup) {
        if (subgroup.id == this.currentSubGroupId) {
          continue;
        }

        const lowCostData = subGroupDetail.find(
          a => a.suggestionType == "low-cost"
        );

        if (lowCostData) {
          if (subgroup.lowCostIngredients.length > 0) {
            const prepareLowCost = {
              ...lowCostData,
              subGroupId: subgroup.id,
            };
            this.dataForGenerateAll[groupIndex].subGroupIngredients.push(
              prepareLowCost
            );
            this.selectedCardData.push(
              "lowCost" + ingredients.groupId + subgroup.id
            );
          }
        }

        const expiryData = subGroupDetail.find(
          a => a.suggestionType == "expiry"
        );

        if (expiryData) {
          if (subgroup.expiredSoonIngredients.length > 0) {
            const prepareExpiryCost = {
              ...expiryData,
              subGroupId: subgroup.id,
            };
            this.dataForGenerateAll[groupIndex].subGroupIngredients.push(
              prepareExpiryCost
            );
            this.selectedCardData.push(
              "expiry" + ingredients.groupId + subgroup.id
            );
          }
        }
      }
      let subGroupIngredients =
        this.dataForGenerateAll[groupIndex].subGroupIngredients;
      this.dataForGenerateAll[groupIndex].subGroupIngredients = [
        ...new Set(subGroupIngredients.map(JSON.stringify)),
      ].map(JSON.parse);

      this.selectedCardData = [...new Set(this.selectedCardData)];
    },
    setCurrentSubGroup(subGroupId) {
      this.currentSubGroupId = +subGroupId;
    },
    updateRationId() {
      this.rationId = this.$route.query.rationId;
    },
    openSaveRationDialog(title, content) {
      this.saveRation = true;
      this.title = title;
      this.content = content;
    },
    expandToggleFirst() {
      console.log(this.rationPriority, "ration prio");
      this.isExpandedFirst = !this.isExpandedFirst;
    },
    expandToggleSecond() {
      this.isExpandedSecond = !this.isExpandedSecond;
    },
    rationCreated() {
      this.saveRation = false;
      this.createRation = true;
      this.$notify({
        title: "Success!",
        text: "Ration successfully saved.",
        type: "success",
      });
      this.getFeedSuggestions();
    },
    next() {
      this.$router.push({ name: "IngredientsSelection" });
    },
    back() {
      this.$router.go(-1);
    },
    // TODO:: update with dynamic payload
    async getFeedSuggestions() {
      this.startLoading();
      console.log(this.getRationSuggestionInput);
      await this.$apollo
        .mutate({
          mutation: generateSuggestions,
          variables: {
            generateSuggestionsInput: { ...this.getRationSuggestionInput },
          },
        })
        .then(res => {
          this.stopLoading();
          if (res?.data) {
            this.stopLoading();
            const data = FeedService.getIngredientTotalWithData(
              res?.data?.generateSuggestions
            );
            // let data = res?.data?.generateSuggestions;
            this.groupIngradients = {
              rationAnimalGroups: data,
            };
          }
          // this.groupIngradients = res?.data?.generateSuggestions;
          console.log(this.groupIngradients);
          this.closeModal(true);
        })
        .catch(error => {
          this.stopLoading();
          console.log(error?.graphQLErrors);
          if (error?.graphQLErrors?.length) {
            this.$notify({
              title: "Error!",
              text: error?.graphQLErrors[0].message,
              type: "error",
            });
          }
        });
    },
    async generateAll() {
      this.startLoading();
      await this.$apollo
        .mutate({
          mutation: GenerateIngredientAllGroup,
          variables: {
            generateIngredientAllGroupInput: {
              rationId: this.rationId,
              animalGroupsForIngredient: this.dataForGenerateAll,
            },
          },
        })
        .then(res => {
          this.stopLoading();
          if (res?.data) {
            this.saveRation = true;
            this.rationLists = [
              { ...res?.data?.generateIngredientAllGroup, updateMode: false },
            ];
            // this.rationLists = res?.data?.generateIngredientAllGroup.map(
            //   (sub) => {
            //     return { ...sub, updateMode: false };
            //   }
            // );
          }
          console.log(
            "generate all data",
            res?.data?.generateIngredientAllGroup
          );

          this.closeModal(true);
        })
        .catch(error => {
          this.$notify({
            title: "Error!",
            text: error?.graphQLErrors[0].message,
            type: "error",
          });
          this.stopLoading();
        });

      this.stopLoading();
    },

    preparedSubGroupIngredientData() {
      console.log(
        "this this ===============>>>>>>>>>>>>>>> ",
        this.groupIngradients
      );
      return this.dataForGenerateAll.map(group => {
        let subGroupIngredients = group.subGroupIngredients.map(subgroup => {
          return { ...subgroup, updateMode: false };
        });

        return {
          groupId: group.groupId,
          subGroupIngredients,
        };
      });
    },

    getSubGroupAnimalDetails(item, subGroup) {
      this.subGroups = item;
      this.rationAnimalGeneratedSubGroupId = Number(subGroup.id);
      this.showSubGroupAnimalDetails = true;
    },
    generateRations(rationLists) {
      console.log(rationLists);
      this.rationLists = rationLists;
      this.saveRation = true;
      this.loading = false;
    },

    generateAllData(addOrRemove, data) {
      if (addOrRemove == "add") {
        const dataToPush = {
          groupId: data.groupId,
          subGroupIngredients: [
            {
              subGroupId: data.subGroupId,
              percentageNutrientRequirement: data.percentageNutrientRequirement,
              suggestionType: data.suggestionType,
            },
          ],
        };
        if (this.dataForGenerateAll.length == 0) {
          this.dataForGenerateAll.push(dataToPush);
        } else if (
          this.dataForGenerateAll.findIndex(g => g.groupId == data.groupId) ==
          -1
        ) {
          this.dataForGenerateAll.push(dataToPush);
        } else {
          const groupIndex = this.dataForGenerateAll.findIndex(
            g => g.groupId == data.groupId
          );

          this.dataForGenerateAll[groupIndex].subGroupIngredients.push(
            dataToPush.subGroupIngredients[0]
          );
          let subGroupIngredients =
            this.dataForGenerateAll[groupIndex].subGroupIngredients;

          this.dataForGenerateAll[groupIndex].subGroupIngredients = [
            ...new Set(subGroupIngredients.map(JSON.stringify)),
          ].map(JSON.parse);
        }
      } else {
        const groupIndex = this.dataForGenerateAll.findIndex(
          g => g.groupId == data.groupId
        );

        this.dataForGenerateAll[groupIndex].subGroupIngredients.splice(
          this.dataForGenerateAll[groupIndex].subGroupIngredients.findIndex(
            a =>
              a.subGroupId == data.subGroupId &&
              a.suggestionType == data.suggestionType
          ),
          1
        );

        if (
          this.dataForGenerateAll[groupIndex].subGroupIngredients.length == 0
        ) {
          this.dataForGenerateAll.splice(
            this.dataForGenerateAll.findIndex(a => a.groupId == data.groupId),
            1
          );
        }
      }
    },
  },
  mixins: [loadingMixin, generalMixin],
};
</script>

<style lang="scss" scoped>
.gray2 {
  background-color: #f2f2f2 !important;
  border-color: #f2f2f2 !important;
}

.orange2 {
  background-color: #fff7ec !important;
  border-color: 1px solid #ffb443 !important;
}
.border-active {
  border: 1px solid green !important;
}

:deep.subHeader .v-data-table-header {
  background-color: #fde9c7 !important;
}

.divider {
  border-right: 1px solid #6a7784;
  padding: 0 14px;
  cursor: pointer;
}

.v-input--selection-controls {
  margin: 0;
  padding: 0;
}
</style>
